import {
  aSuppressList,
  aSuppressListItemPage,
  aSuppressListPage,
  mockSuppressedListOperationQuery,
  mockSuppressedListSelectOperationQuery,
  mockSuppressedListsOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const SUPPRESSED_LIST_DATA = {
  name: `Test Suppressed List ${Date.now()}`,
  description: `Test suppressed list description`,
  timeToLive: 3,
  updatedDescription: `Test suppressed list description updated`,
  updatedTimeToLive: 4,
};

export const suppressedListHandler = ({
  id,
  name,
  description,
  timeToLiveInSeconds,
}) => ({
  __typename: 'Query',
  suppressLists: aSuppressListPage({
    hasNextPage: false,
    objects: [
      aSuppressList({
        defaultTtl: timeToLiveInSeconds,
        description,
        id,
        items: aSuppressListItemPage({
          hasNextPage: false,
          objects: [],
          total: 0,
        }),
        name,
        targetColumn: '1',
      }),
    ],
    total: 1,
  }),
  suppressListItemCount: 1,
  suppressListItemLimit: 5,
});

export const handlers = [
  mockSuppressedListOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          suppressList: aSuppressList(),
        },
      });
    }
  ),
  mockSuppressedListsOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          suppressLists: aSuppressListPage(),
          suppressListItemLimit: 10000,
          suppressListItemCount: aSuppressListPage().total,
        },
      });
    }
  ),
  mockSuppressedListSelectOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          suppressLists: aSuppressListPage(),
        },
      });
    }
  ),
];
